var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPldBlogFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6V0H2a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8h-6a2 2 0 01-2-2zM4.25 9.5h7.5a.75.75 0 110 1.5h-7.5a.75.75 0 110-1.5zm0 2.75h7.5a.75.75 0 110 1.5h-7.5a.75.75 0 110-1.5zm0 2.75h7.5a.75.75 0 110 1.5h-7.5a.75.75 0 110-1.5zM9.5 6V.5l6 6H10a.5.5 0 01-.5-.5z",
    fill: "#333230"
  })));
}
export default SvgPldBlogFilled;